/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
function updateSavingsBadge() {
  document.querySelectorAll('[data-price-off-badge]').forEach(function(badge) {
    const priceWrap = badge.closest('.product__price__wrap');
    const amountEl = badge.querySelector('[data-price-off-amount]');

    if (!priceWrap || !amountEl) return;

    // Copia a zona dos preços e remove o próprio badge
    // para não confundir o valor da poupança com os preços.
    const clone = priceWrap.cloneNode(true);
    clone.querySelectorAll('[data-price-off-badge]').forEach(function(el) {
      el.remove();
    });

    const text = clone.textContent.replace(/\s/g, '');

    // Procura valores em euros, ex.: €39,99 / €89,99
    const matches = text.match(/€\d+(?:[.,]\d{1,2})?/g);

    if (!matches || matches.length < 2) return;

    const values = matches.map(function(value) {
      return parseFloat(
        value
          .replace('€', '')
          .replace(/\./g, '')
          .replace(',', '.')
      );
    }).filter(function(value) {
      return !isNaN(value);
    });

    if (values.length < 2) return;

    const salePrice = Math.min.apply(null, values);
    const comparePrice = Math.max.apply(null, values);

    if (comparePrice <= salePrice) return;

    const saving = comparePrice - salePrice;
    const savingText = '€' + saving.toFixed(2).replace('.', ',');

    if (amountEl.textContent !== savingText) {
      amountEl.textContent = savingText;
    }
  });
}


// Atualizar ao carregar a página
document.addEventListener('DOMContentLoaded', function() {
  updateSavingsBadge();

  // O tema altera o preço quando se muda de variante.
  // Este observador volta a calcular automaticamente.
  const observer = new MutationObserver(function() {
    updateSavingsBadge();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
});

  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
